export enum UserRateClassType {
  Class1 = 'Class1',
  Class2 = 'Class2',
  Class3 = 'Class3',
}
